"use client";
import { LoginForm } from "@/components/auth/LoginForm.js";


interface LoginPageProps {
    environment: string;
}


export function LoginPage({ environment }: LoginPageProps) {
    return (
        <LoginForm
            backPieces={[{ label: "Home", href: "/" }]}
            environment={environment} />
    );
}
